import { createFileRoute, redirect } from "@tanstack/react-router";

// Signup is admin-invite-only. Self-registration is disabled.
// Admins create accounts via Admin → Students → Bulk Import (CSV).
//
// No `head:` here on purpose: `beforeLoad` always redirects, so this route never
// renders and head metadata on it would be dead code. /signup is covered by the
// `Disallow: /signup` line in robots.txt instead.
export const Route = createFileRoute("/signup")({
  beforeLoad: () => {
    throw redirect({ to: "/login" });
  },
  component: () => null,
});
